export const version = '53';
export const releaseDate = '6';
export const releaseMonth = 'July';
export const releaseYear = '2026';
